import React, { type ComponentProps, lazy, Suspense } from 'react'
import { Button, Separator, useOverlay } from '@fs/zion-ui'
import { ContentUpload } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { useUploadTree } from '../../../services/useUploadTree'

const UploadTreeOverlay = lazy(() => import('../import-page/UploadTreeOverlay'))

type Props = {
  emphasis?: ComponentProps<typeof Button>['emphasis']
}

export default function UploadTreeButton({ emphasis }: Props): JSX.Element | null {
  const overlay = useOverlay()
  const { t } = useTranslation()
  const { canAccessCET, disableCreateTreeButton, maxTrees, refetchData } = useUploadTree()

  // Users without CET access cannot create a tree, so hide the button entirely
  if (!canAccessCET) return null

  return (
    <>
      <Separator size="xxs" />
      <Button
        disabled={disableCreateTreeButton}
        emphasis={emphasis}
        disabledDescription={
          maxTrees ? t('tree-import.create-tree-max-groups.error', { maxGroups: maxTrees }) : undefined
        }
        Icon={ContentUpload}
        data-testid="upload-gedcom-button.upload-gedcom.button"
        onClick={overlay.handleClick}
        linkName="Upload Gedcom Button"
      >
        {t('tree-import.create-files.button')}
      </Button>

      <Suspense fallback="">
        {(overlay.isOpen || overlay.transitioning) && <UploadTreeOverlay overlay={overlay} onSuccess={refetchData} />}
      </Suspense>
    </>
  )
}
